import { useCallback } from 'react'
import { useQueryClient } from 'react-query'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { logOut } from '../userSlice'
import { useNavigate, useLocation } from 'react-router-dom'
import { clearAuthHeader } from '@user/store/services/crud'
import { clearCookie, setCookie } from '@sales-center/common'

export const useLogOut = () => {
  const dispatch = useAppDispatch()
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const location = useLocation()

  const logout = useCallback(
    (disabledType?: number | string) => {
      if (disabledType)
        setCookie(
          'deactivated',
          'Authentication error- contact your system administrator.',
        )
      queryClient.clear()
      clearAuthHeader()
      clearCookie('impersonated')
      dispatch(logOut())

      if (location.pathname !== '/') navigate('/')
    },
    [dispatch, navigate, location.pathname, queryClient],
  )

  return logout
}
